import React, { useContext, useEffect } from "react";
import Header from "./components/Headers/Header";
import Footer from "./components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import userContext from "./components/UseContext/UseContext";

function Layout() {
  const navicate = useNavigate();
  const { logOutContext, subdomain } = useContext(userContext);
  const vendorsubdomain = localStorage.getItem("vendorsubdomain");
 const adminId = localStorage.getItem("adminId");
const vendorsccesstoken = localStorage.getItem("vendorsccesstoken");

  // useEffect(() => {
  //   if (!adminId && !vendorsccesstoken) {
  //     navicate(vendorsubdomain ? `/${vendorsubdomain}/login` : "/login");
  //   }
  // }, [logOutContext?.logOut]);
  useEffect(() => {
    const isAdminIdValid =
      adminId && adminId !== "null" && adminId !== "undefined";
    const isVendorTokenValid =
      vendorsccesstoken &&
      vendorsccesstoken !== "null" &&
      vendorsccesstoken !== "undefined";

    if (!isAdminIdValid && !isVendorTokenValid) {
      navicate(vendorsubdomain ? `/${vendorsubdomain}/login` : "/login");
    }
  }, [logOutContext?.logOut]);

  return (
    <>
      <Header />
      {/* <Footer /> */}
    </>
  );
}

export default Layout;
